export const lineItems = (invoice) =>
({
  style: 'lineItems',
  table: {
      headerRows: 1,
      widths: ["*", 70, 70, 70],
      heights: 30,
      body: generateLineItems(invoice)
    },
    layout: 'noBorders'
});

const generateLineItems = (invoice) => {
  const lineItems = [];

  lineItems.push([
    {text: 'Description', style: 'tableHeaderText'},
    {text: 'Quantity', style: 'tableHeaderNumber'},
    {text: 'Unit Price', style: 'tableHeaderNumber'},
    {text: 'Total', style: 'tableHeaderNumber'}
  ]);

  invoice.lineItems.forEach(lineItem => {
    const row = [
      lineItem.description,
      {text: lineItem.quantity, alignment: "right"},
      {text: `$${Number(lineItem.unitPrice).toFixed(2)}`, alignment: "right"},
      {text: `$${Number(lineItem.total).toFixed(2)}`, alignment: "right"},
    ];
    lineItems.push(row);
  });

  return lineItems;
}



// WEBPACK FOOTER //
// ./src/store/generators/PDF/invoice/lineItems.js